// return boolean if field should be hidden
function isEmail(value) {
  return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    value?.toLowerCase?.(),
  );
}

function isValid(field) {
  if (field.element === 'email') {
    return isEmail(field.value);
  }

  return true;
}

export default function isFieldHidden(field = {}, isPreview = false) {
  if (!field.hidden) return false;

  if (field.hidden && isPreview) return true;

  if (field.hidden && !field.required) return true;

  if (field.hidden && field.required && field.value && isValid(field)) {
    return true;
  }

  return false;
}
